import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class VerticalComposedDayTimesheetComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        // Ratios and dimensions
        const geometryWidthRatio = geometry.width / 1050.0;
        const geometryHeightRatio = geometry.height / 1200.0;

        const smallHeight = 50 * geometryHeightRatio * dimentionsRatio;
        const descriptionWidth = 250 * geometryWidthRatio * dimentionsRatio;
        const descriptionHeight = 150 * geometryHeightRatio * dimentionsRatio;
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        const componentSecundaryColor = "#EBF5FA";

        // Top and bottom margins are proportional to component height
        const topMargin = 0.1 * geometryHeight; // 10% of the component height
        const bottomMargin = 0.1 * geometryHeight; // 10% of the component height
        const verticalAvailableSpace = geometryHeight - descriptionHeight - topMargin - bottomMargin;

        const margin = (geometryWidth - 3 * descriptionWidth) / 4; // Horizontal margin between columns
        const descriptionRowSeparation = 30 * geometryHeightRatio * dimentionsRatio; // Space between description and rows
        const rowSpacing = 20 * geometryHeightRatio * dimentionsRatio; // Space between rows

        // Calculate the number of rows based on available space
        const totalRowHeight = smallHeight + rowSpacing;
        const numberOfRows = Math.floor((verticalAvailableSpace - descriptionRowSeparation) / totalRowHeight);

        // Create 3 columns
        const columns = [];
        for (let i = 0; i < 3; i++) {
            const offsetX = geometry.drawPositionX + margin + i * (descriptionWidth + margin);

            const rows = [];
            for (let j = 0; j < numberOfRows; j++) {
                const rowPosY = geometry.drawPositionY + topMargin + descriptionHeight + descriptionRowSeparation + j * totalRowHeight;

                rows.push(
                    <Rect
                        key={`vcdtc-row-column-${i}-${j}`}
                        x={offsetX}
                        y={rowPosY}
                        width={descriptionWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor}
                    />
                );
            }

            const column = (
                <Group key={`vcdtc-row-${i}`}>
                    {/* Description */}
                    <Rect
                        x={offsetX}
                        y={geometry.drawPositionY + topMargin}
                        width={descriptionWidth}
                        height={descriptionHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor}
                    />
                    {/* Rows */}
                    {rows}
                </Group>
            );

            columns.push(column);
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null}>
                {/* Main component border */}
                <Rect
                    x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color}
                />
                {/* Columns */}
                {columns}
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/VerticalComposedDayTimesheetComponentCanvas.js